import React, { Component } from 'react';
import ReactStars from 'react-stars';
import { Select } from '../../inputs';
import { PlayerAvatar, ManagerMeta, PlayerFeedback } from '../../cards';
import { Cancel, Confirm, Text } from '../../buttons';
import { SmallLoading } from '../../common';
import './MatchSquadManager.css';

class MatchSquadManagerUser extends Component {
	constructor(props) {
		super(props);
		this.state = {
			ratingId: 0,
			ratings: {
				0: { name: 'Vote', id: 1 },
				1: { name: '0.5', id: 1 },
				2: { name: '1', id: 2 },
				3: { name: '1.5', id: 3 },
				4: { name: '2', id: 4 },
				5: { name: '2.5', id: 5 },
				6: { name: '3', id: 6 },
				7: { name: '3.5', id: 7 },
				8: { name: '4', id: 8 },
				9: { name: '4.5', id: 9 },
				10: { name: '5', id: 10 },
				11: { name: '5.5', id: 11 },
				12: { name: '6', id: 12 },
				13: { name: '6.5', id: 13 },
				14: { name: '7', id: 14 },
				15: { name: '7.5', id: 15 },
				16: { name: '8', id: 16 },
				17: { name: '8.5', id: 17 },
				18: { name: '9', id: 18 },
				19: { name: '9.5', id: 19 },
				20: { name: '10', id: 20 },
			},
			ratingsById: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
			temp: false,
			tempText: 'You',
			edit: true,
		};
		this.onRatingUserConfirm = this.onRatingUserConfirm.bind(this);
		this.onRatingUserChangeSelect = this.onRatingUserChangeSelect.bind(this);
	}
	componentDidMount() {}
	componentWillUnmount() {}

	onRatingChange = val => {
		this.props.onRatingChange(val);
	};

	onRatingUserChange = val => {
		this.setState({
			tempRating: val,
			temp: true,
			tempText: 'Confirm',
		});
	};

	onRatingUserChangeSelect = val => {
		this.setState({
			tempRating: Number(parseFloat(this.state.ratings[val].name).toFixed(1)),
			temp: true,
			tempText: 'Confirm',
		});
	};

	onRatingUserConfirm = () => {
		this.props.onUserRatingChange(this.state.tempRating, this.props.playerReport);
		this.setState({
			tempRating: 0,
			temp: false,
			tempText: 'You',
			edit: false,
		});
	};

	onGoalChange = val => {
		if (typeof val === 'undefined' || val === '') {
			val = '0';
		}
		this.props.onGoalChange(val, this.props.playerReport);
	};
	onCardChange = val => {
		if (typeof val === 'undefined' || val === '') {
			val = '0';
		}
		this.props.onCardChange(parseInt(val, 10), this.props.playerReport);
	};
	onReviewChange = val => {
		this.props.onTextChange(val, this.props.playerReport);
	};
	onPositionChange = val => {
		this.props.onPositionChange(this.props.positions[val], this.props.playerReport);
	};
	onRatingChange = val => {
		this.props.onRatingChange(val, this.props.playerReport);
	};
	onUserRatingChange = val => {
		this.props.onUserRatingChange(val, this.props.playerReport);
	};

	_renderUserStars = () => {
		if (this.state.temp) {
			return (
				<div className="item-large">
					<div className="flexContainerRow">
						<div className="item-1">
							<span className="ratingScore">{this.state.tempRating}</span>
						</div>
						<div className="item-1 confirmRating borderRight">
							<Cancel
								action={() =>
									this.setState({
										tempRating: 0,
										temp: false,
										edit: true,
										tempText: 'You',
									})
								}
							/>
						</div>
						<div className="item-1 confirmRating">
							<Confirm action={this.onRatingUserConfirm} />
						</div>
					</div>
				</div>
			);
		}
		if (this.state.edit) {
			return (
				<div className="item-1 center">
					<div className="userStarsDesk">
						<ReactStars
							count={10}
							onChange={this.onRatingUserChange}
							size={20}
							value={this.props.playerReport.userRating}
							color1={'#ffffff'}
							color2={'#ffc000'}
						/>
					</div>
					<div className="userStarsMob">
						<Select
							prompt="Vote"
							currentVal={this.state.ratingId}
							options={this.state.ratings}
							optionsById={this.state.ratingsById}
							onChange={this.onRatingUserChangeSelect}
						/>
					</div>
				</div>
			);
		}
		return <SmallLoading />;
	};

	_renderFullCard = () => (
		<div className="flexContainerRow matchSquadPlayer grey2 grey1-border-shadow-bottom">
			<div className="col1 avaWrap white">
				<PlayerAvatar
					firstName={this.props.player.firstName}
					surname={this.props.player.surname}
					avatar={this.props.player.playerAvatar}
				/>
			</div>
			<div className="col2_1 metaGrey">
				<ManagerMeta
					player={this.props.player}
					playerReport={this.props.playerReport}
					positions={this.props.positions}
					onPositionChange={this.onPositionChange}
				/>
			</div>
			<div className="playerFeedback white grey1-border">
				<PlayerFeedback
					playerReport={this.props.playerReport}
					onRatingChange={this.onRatingChange}
					onReviewChange={this.onReviewChange}
					userRating
					hasVoted={this.props.hasVoted[this.props.playerReport.playerDoc]}
					onUserRatingChange={this.onUserRatingChange}
				/>
			</div>
		</div>
	);

	render() {
		if (this.props.reveal || this.props.hasVoted[this.props.playerReport.playerDoc]) {
			return this._renderFullCard();
		}
		return (
			<div className="flexContainerRow matchSquadPlayer grey1-border-shadow-bottom">
				<div className="col1 avaWrap white">
					<PlayerAvatar
						firstName={this.props.player.firstName}
						surname={this.props.player.surname}
						avatar={this.props.player.playerAvatar}
					/>
				</div>
				<div className="col2">
					<div className="flexContainerRow">
						<div className="generic-inner">
							<div className="note">
								<p>
									Vote to reveal the user average and to see how arseblog rated{' '}
									{this.props.player.surname}
								</p>
								{this._renderUserStars()}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export { MatchSquadManagerUser };



// WEBPACK FOOTER //
// ./src/components/layouts/matchSquadManager/MatchSquadManagerUser.js